import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface AuditLog {
  id: number;
  ts: string;
  actor: string;
  action: string;
  meta: string;
}

const AuditLogs: React.FC = () => {
  const { user } = useAuth();
  const [auditLogs, setAuditLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.role === 'admin') {
      fetchAuditLogs();
    }
  }, [user]);

  const fetchAuditLogs = async () => {
    try {
      // Моковые данные
      const mockData: AuditLog[] = [
        {
          id: 1,
          ts: '2024-01-01T12:00:00Z',
          actor: 'system',
          action: 'payment_created',
          meta: '{"paymentId": 1, "amount": 100000}'
        }
      ];
      
      setAuditLogs(mockData);
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatAction = (action: string) => {
    const actionMap: { [key: string]: string } = {
      'payment_created': 'Создан платеж',
      'payment_confirmed': 'Платеж подтвержден',
      'payment_rejected': 'Платеж отклонен',
      'operator_created': 'Создан оператор',
      'operator_updated': 'Оператор обновлен',
      'operator_deleted': 'Оператор удален'
    };
    
    return actionMap[action] || action;
  };

  const formatMeta = (meta: string) => {
    try {
      const parsed = JSON.parse(meta);
      return Object.entries(parsed)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
    } catch {
      return meta;
    }
  };

  if (user?.role !== 'admin') {
    return <div className="text-center text-red-600">Доступ запрещен</div>;
  }

  if (loading) {
    return <div className="text-center">Загрузка...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="py-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Аудит лог</h1>

        <div className="bg-white shadow overflow-hidden sm:rounded-md">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">История действий</h3>
          </div>
          
          {auditLogs.length === 0 ? (
            <div className="px-6 py-4 text-center text-gray-500">
              Логи не найдены
            </div>
          ) : (
            <ul className="divide-y divide-gray-200">
              {auditLogs.map((log) => (
                <li key={log.id} className="px-6 py-4">
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3">
                        <span className="text-sm font-medium text-gray-900">
                          {formatAction(log.action)}
                        </span>
                        <span className="text-sm text-gray-500">
                          {new Date(log.ts).toLocaleString('ru-RU')}
                        </span>
                      </div>
                      <div className="mt-1 text-sm text-gray-500">
                        <span className="font-medium">Пользователь:</span> {log.actor}
                      </div>
                      {log.meta && (
                        <div className="mt-1 text-sm text-gray-500">
                          <span className="font-medium">Детали:</span> {formatMeta(log.meta)}
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditLogs;
